import Link, { PageLink } from "@client/controls/Link/container";
import { useI18n } from "@common/hooks/i18n";
import * as React from "react";

export interface LoginProps {
  loginPageId?: string;
  logoutUrl?: string;
}

const Login = (props: LoginProps) => {
  const i18n = useI18n();

  return (
    <div className="login">
      {props.loginPageId ? (
        <PageLink title={i18n.login} rel="nofollow" pageId={props.loginPageId}>
          {i18n.login}
        </PageLink>
      ) : (
        <Link
          title={i18n.logout}
          rel="nofollow"
          onClick={() =>
            window.location.replace(`${props.logoutUrl}?returnUrl=${encodeURIComponent(window.location.pathname)}`)
          }
        >
          {i18n.logout}
        </Link>
      )}
    </div>
  );
};

export default Login;
